module.exports = __webpack_public_path__ + "static/media/adventure.92bbc50e.png";